import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconPause({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `edu-icon edu-icon--${size} ${className}`;
  return <>{!!srText && <span className='sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="M6.7 4h1.6v12H6.7zM11.7 4h1.6v12h-1.6z" /></svg></>;
}
export default IconPause;